import { createSharedComposable } from '@vueuse/core'
import { useRoute } from 'vue-router'

import { useRequestList } from '@/composables/useRequestList'
import enums from '@/plugins/enums'

import { useCurUser } from './useCurUser'

export const useDashboardRequestList = createSharedComposable(() => {
  const route = useRoute()
  const { hasRole, accessibleModules, is: userIs } = useCurUser()

  // Determine initial valuation_type based on user role
  // Valuers only see modules they're a valuer for, others see all accessible modules
  const initialModules = userIs.value.valuer
    ? accessibleModules.value.filter(m => hasRole('valuer', m))
    : accessibleModules.value

  const requestList = useRequestList({
    isUserRequests: route.query.valuation_request_refs ? false : route.query.isUserRequests !== 'false',
    filters: [row => row.payment_summary?.status !== 'payment-pending' || !hasRole('valuer', 'ovm', true)],
    serverSideFilters: {
      status: [
        enums.requestStatus.DRAFT,
        enums.requestStatus.SUBMITTED,
        enums.requestStatus.VALUED,
        enums.requestStatus.AWAITING_ONSITE,
        enums.requestStatus.OUT_OF_SCOPE,
        enums.requestStatus.FAILED,
      ],
      order_by: 'modified_at__desc',
    },
    colFilters: {
      valuation_type: initialModules,
    },

    enableDatePagination: true,
  })

  return requestList
})
